/**
 * Typed route constants. Do not sprinkle route strings across the app
 * (spec §8.4).
 */
export const ROUTES = {
  root: '/',
  login: '/login',
  authComplete: '/auth/complete',
  onboarding: '/onboarding',
  account: '/account',
  profile: '/account/profile',
  connections: '/account/connections',
  security: '/account/security',
  logout: '/logout',
  error: '/error',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
